import {BaseCachedService} from './Core/BaseCachedService';

class ProcedureService extends BaseCachedService {
    get Url() { return super.Url + "/procedures"; }
    get ModelName() { return "Procedures"; }
    get PrimaryKeyProperty() { return "procedureId"; }

}

export const service = new ProcedureService();

